var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363",
    transform: "translate(-6 -56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght400_GRAD0_opsz40",
    d: "M9.936,27a1.915,1.915,0,0,1-1.42-.611,1.991,1.991,0,0,1-.6-1.437V8.056H7.675A.991.991,0,0,1,6.667,7.047a1.015,1.015,0,0,1,.29-.749.976.976,0,0,1,.719-.29h4.858A.991.991,0,0,1,13.542,5h5.805a.991.991,0,0,1,1.008,1.008h4.858a.951.951,0,0,1,.719.306,1.027,1.027,0,0,1,.29.733.991.991,0,0,1-1.008,1.008H24.97v16.9a1.991,1.991,0,0,1-.6,1.437,1.915,1.915,0,0,1-1.42.611Zm0-18.944v16.9H22.953V8.056ZM12.93,21.378a1.008,1.008,0,1,0,2.017,0V11.631a1.013,1.013,0,0,0-.29-.749,1.033,1.033,0,0,0-1.436,0,1.013,1.013,0,0,0-.29.749Zm5.012,0a1.008,1.008,0,1,0,2.017,0V11.631a1.013,1.013,0,0,0-.29-.749,1.033,1.033,0,0,0-1.436,0,1.013,1.013,0,0,0-.29.749ZM9.936,8.056v0Z",
    transform: "translate(13.556 65)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_644",
    "data-name": "Rectangle 644",
    width: 48,
    height: 48,
    transform: "translate(6 56)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.b82350f85e209b5f31ef3b033df53abb.svg";
export { ForwardRef as ReactComponent };